<template>
  <div class="field-control">
    <div class="panel">
      <div class="panel-header">
        <h2 class="panel-title"><i class="fas fa-thumb-tack"></i> 置顶贴片功能</h2>
        <div class="header-actions">
          <button class="btn btn-success" @click="addCommand">+ 添加贴片内容</button>
          <button class="btn btn-import" @click="importCommands">导入</button>
          <button class="btn btn-export" @click="exportCommands">导出</button>
          <button class="btn btn-danger" @click="clearCommands">清空</button>
          <button 
            class="btn btn-overlay" 
            :class="{ 'btn-overlay-active': $store.state.stickyStatus  }"
            @click="toggleOverlay"
          >
            {{$store.state.stickyStatus  ? '停止置顶贴片' : '开始置顶贴片' }}
          </button>
        </div>
      </div>
      
      <div class="control-settings">
        <div class="setting-row">
          <div class="setting-item">
            <label>贴片组</label>
            <div class="custom-select" @click="toggleGroupDropdown">
              <div class="custom-select-value">
                {{ getSelectedGroupName }}
              </div>
              <i class="fas fa-chevron-down select-arrow"></i>
              <div v-if="showGroupDropdown" class="custom-select-dropdown">
                <div 
                  class="dropdown-item" 
                  :class="{ selected: config.group_id == 0 }"
                  @click.stop="selectGroup(0)"
                >
                  默认贴片组
                </div>
                <div 
                  v-for="group in groups" 
                  :key="group.id" 
                  class="dropdown-item group-item"
                  :class="{ selected: config.group_id == group.id }"
                  @click.stop="selectGroup(group.id)"
                >
                  <span>{{ group.name }}</span>
                  <button
                      class="delete-group-btn"
                      @click.stop="deleteGroup(group.id)"
                      title="删除此回复组"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
            <button class="btn btn-sm btn-secondary" @click="showImageModal = true">+ 新增</button>
          </div>
          
          <div class="setting-item">
            <label>贴片顺序</label>
            <div class="custom-select" @click="toggleOrderDropdown">
              <div class="custom-select-value">
                {{ config.control_order == 0 ? '正常顺序' : '随机顺序' }}
              </div>
              <i class="fas fa-chevron-down select-arrow"></i>
              <div v-if="showOrderDropdown" class="custom-select-dropdown">
                <div 
                  class="dropdown-item" 
                  :class="{ selected:config.control_order == 0 }"
                  @click.stop="selectOrder(0)"
                >
                  正常顺序
                </div>
                <div 
                  class="dropdown-item" 
                  :class="{ selected: config.control_order == 1 }"
                  @click.stop="selectOrder(1)"
                >
                  随机顺序
                </div>
              </div>
            </div>
          </div>
          
          <div class="setting-item">
            <label>贴片频率</label>
            <div class="frequency-control">
              <input type="number" v-model.number="config.send_freq_min" class="frequency-input" min="80" max="300" @change="updateConfig">
              <span class="frequency-separator">~</span>
              <input type="number" v-model.number="config.send_freq_max" class="frequency-input" min="125" max="300" @change="updateConfig">
              <span class="frequency-unit">秒</span>
            </div>
          </div>
          <div class="checkbox-group">
            <label class="checkbox-item">
              <input type="checkbox" v-model="config.rand_space" @change="updateConfig">
              <span class="checkbox-custom"></span>
              <span>随机空格</span>
            </label>

          </div>
        </div>
        

      </div>
      
      <div class="commands-list">
        <div class="list-header">
          <div class="header-command">序号</div>
          <div class="header-content">场控内容</div>
          <div class="header-actions">操作</div>
        </div>
        
        <div v-if="commands?.length === 0" class="empty-state">
          <i class="fas fa-inbox"></i>
          <p>暂无场控指令</p>
        </div>
        <div v-for="(command, index) in commands" :key="command.id" class="command-item">
          <div class="item-command">{{ (queryForm.page - 1) * queryForm.limit + index + 1 }}</div>
          <div class="item-content">{{ command.content }}</div>
          <div class="item-actions">
            <button class="btn-action edit" @click="editCommand(command)"><i class="fas fa-edit"></i></button>
            <button class="btn-action delete" @click="deleteCommand(command.id)"><i class="fas fa-trash"></i></button>
          </div>
        </div>
      </div>

      <div class="pagination-container">
        <div class="pagination">
          <button class="page-btn" @click="previousPage" :disabled="queryForm.page === 1">
            <i class="fas fa-chevron-left"></i>
          </button>
          <div class="page-info">
            第 {{ queryForm.page }} 页，共 {{ queryForm.pageCount }} 页
          </div>
          <button class="page-btn" @click="nextPage" :disabled="queryForm.page >= queryForm.pageCount">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
    
    <!-- 添加/编辑指令弹窗 -->
    <div class="modal" v-if="showCommandModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ editingCommand ? '编辑贴片内容' : '添加贴片内容' }}</h3>
          <button class="close-modal" @click="showCommandModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>贴片内容</label>
            <textarea v-model="currentCommand.content" :placeholder="editingCommand ? '' : '请输入贴片内容，多条一行一个，单行建议不要超过45字。'" class="form-textarea" rows="4"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="showCommandModal = false">取消</button>
          <button class="btn btn-primary" @click="saveCommand">保存</button>
        </div>
      </div>
    </div>
    
    <!-- 图片功能弹窗 -->
    <div class="modal" v-if="showImageModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>新增贴片组</h3>
          <button class="close-modal" @click="showImageModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>贴片组名称</label>
            <input type="text" v-model="newGroupName" placeholder="请输入贴片组名称" class="form-input">
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="showImageModal = false">取消</button>
          <button class="btn btn-primary" @click="saveGroup">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import {delay, getRandomInt} from "@/utils/function";

export default {
  name: 'StickyOverlay',
  data() {
    return {
      queryForm: {
        group_id: 0,
        limit: 4,
        page: 1,
        pageCount: 0,
      },
      config: {},
      selectedGroup: '0',
      groups: [],
      showGroupDropdown: false,
      showOrderDropdown: false,
      replyOrder: 'normal',
      minFrequency: 30,
      maxFrequency: 60,
      randomSpace: false,
      randomEmoji: false,
      searchKeyword: '',
      selectAll: false,
      currentPage: 1,
      pageSize: 5,
      isOverlayRunning: false,
      showCommandModal: false,
      showImageModal: false,
      editingCommand: null,
      newGroupName: '',
      currentCommand: {
        content: ''
      },
      commands: [

      ]
    }
  },
  computed: {
    getSelectedGroupName() {
      if (this.config.group_id == 0) {
        return '默认贴片组'
      }
      const group = this.groups.find(g => g.id === this.config.group_id)
      return group ? group.name : '默认贴片组'



    },

  },
  async mounted() {
    await this.getGroup();
    await this.getConfig();
    await this.getControlList();
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    async updateConfigControl(refresh = false,tips=true) {
      const res = await this.updateConfig(tips);
      if (refresh) {
        this.getControlList();
      }

    },
    async updateConfig(tips=true) {
      const res = await http.post("api/field_control/updateConfig", this.config);
      if(tips){
        if(res.code==200){
          this.$dialog.tips({
            message:res.msg,
            type:"success"
          })
        }else{
          this.getConfig();
          this.$dialog.tips({
            message:res.msg,
            type:"error"
          })
        }
      }

      return res;
    },



    async getConfig() {
      const res = await http.post("api/field_control/getConfig", {type: "top"});
      this.config = res.data;
    },
    async getControlList() {
      this.queryForm.group_id = this.config.group_id;
      const res = await http.post("api/field_control/topControlList", this.queryForm);
      this.commands = res.data.list;
      this.queryForm.pageCount=res.data.pageCount
    },
    async getGroup() {
      const res = await http.get("api/field_control/getGroup");
      this.groups = res.data
    },

    toggleGroupDropdown() {
      this.showGroupDropdown = !this.showGroupDropdown
      if (this.showGroupDropdown) this.showOrderDropdown = false
    },
    toggleOrderDropdown() {
      this.showOrderDropdown = !this.showOrderDropdown
      if (this.showOrderDropdown) this.showGroupDropdown = false
    },
    handleClickOutside(event) {
      if (!event.target.closest('.custom-select')) {
        this.showGroupDropdown = false
        this.showOrderDropdown = false
      }
    },
    selectGroup(groupId) {
      this.config.group_id = groupId
      this.showGroupDropdown = false
      this.updateConfigControl(true)
    },
    selectOrder(order) {
      this.config.control_order = order
      this.showOrderDropdown = false
      this.updateConfig()
    },
    async deleteGroup(groupId) {
      const confirm = await this.$dialog.confirm({
        title: '确认删除',
        message: '确定要删除这个场控组吗？删除后将无法恢复。',
        okText: '删除',
        cancelText: '取消'
      }).catch(() => false)

      if (confirm !== false) {
        const res = await http.post("api/field_control/deleteGroup", {id: groupId})
        if (res.code == 200) {
          this.$dialog.tips({message: res.msg, type: "success"})
          await this.getGroup()
          if (this.config.group_id === groupId) {
            this.config.group_id = 0
            this.updateConfigControl(true,false)

          }
        } else {
          this.$dialog.tips({message: res.msg, type: "error"})
        }
      }
    },
    async toggleOverlay() {
      this.$store.commit("setStickyStatus",!this.$store.state.stickyStatus);
      const res = await this.updateConfig(false);
      if (this.$store.state.stickyStatus) {
        this.$dialog.tips({
          message: "置顶贴片已开启",
          type: "success"
        })
        this.start();
      } else {
        this.$dialog.tips({
          message: "置顶贴片已关闭",
          type: "success"
        })
      }

    },
    async start(){

      const timer = getRandomInt(this.config.send_freq_min, this.config.send_freq_max) * 1000;

      if(this.$store.state.stickyStatus){

        const res=await http.post("api/auto/autoSticky",{index:this.$store.state.stickyIndex})
        if(res.code==200){
          this.$store.commit("setStickyIndex",this.$store.state.stickyIndex+1)
        }
        await delay(timer)
        this.start();

      }




    },
    addCommand() {
      this.editingCommand = null
      this.currentCommand = { content: '' }
      this.showCommandModal = true

    },
    editCommand(command) {
      this.editingCommand = command
      this.currentCommand = { ...command }
      this.showCommandModal = true
    },
    async deleteCommand(id) {

      const confirm = await this.$dialog.confirm({
        title: '确认删除',
        message: '确定要删除？删除后将无法恢复。',
        okText: '删除',
        cancelText: '取消'
      }).catch(() => false)

      if(confirm!==false){
        const res=await http.post("api/field_control/delControl",{type:"top",id})
        if(res.code==200){
          this.getControlList();
          this.$dialog.tips({
            message:res.msg,
            type:"success"
          })

          return;
        }
        this.$dialog.tips({
          message:res.msg,
          type:"error"
        })
      }

    },
    async saveCommand() {

      if (!this.currentCommand.content) return
      if (this.editingCommand) {
        const res = await http.post("api/field_control/updateTopControl", {
          id:this.editingCommand.id,
          content: this.currentCommand.content,
        });

        if (res.code == 200) {
          this.showCommandModal = false
          this.$dialog.tips({message: res.msg, type: "success"});
          this.getControlList();
          return;
        }
        this.$dialog.tips({message: res.msg, type: "error"});


      }else{
        const res = await http.post("api/field_control/addTopControl", {
          group_id: this.config.group_id,
          content: this.currentCommand.content,
        });

        if (res.code == 200) {
          this.showCommandModal = false
          this.$dialog.tips({message: res.msg, type: "success"});
          this.getControlList();
          return;
        }
        this.$dialog.tips({message: res.msg, type: "error"});
      }


    },
   async saveGroup() {
      if (!this.newGroupName) {
        this.$dialog.tips({
          message: "请输入贴片组名称",
          type: "error"
        });
        return
      }
      const res = await http.post("api/field_control/addGroup", {name: this.newGroupName})
      if (res.code == 200) {
        this.getGroup();
        this.config.group_id = parseInt(res.data);
        this.updateConfigControl(true,false)
        this.$dialog.tips({message: res.msg, type: "success"})
        this.newGroupName = ''
        this.showImageModal = false
        return;
      }
    },
    importCommands() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.txt'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.onload =async (event) => {
            try {
              const text = event.target.result;
              console.log(text)
              const res=await http.post("api/field_control/batchImport",{
                type:"top",
                group_id:this.config.group_id,
                contents:text
              })

              if(res.code==200){
                this.getControlList();
                this.$dialog.tips({
                  message:res.msg,
                  type:"success"
                })
                return;
              }
              this.$dialog.tips({
                message:res.msg,
                type:"error"
              })

            } catch (error) {
              this.$dialog.tips({
                message:"导入失败：文件解析错误",
                type:"success"
              })
            }
          }
          reader.readAsText(file)
        }
      }
      input.click()
    },
    async exportCommands() {
      const res=await http.post("api/field_control/export",{type:"top",group_id:this.config.group_id});
      if(res.code==200){
        const dataBlob = new Blob([res.data.text], {type: 'text/plain'})
        const url = URL.createObjectURL(dataBlob)
        const link = document.createElement('a')
        link.href = url
        link.download = res.data.title;
        link.click()
        URL.revokeObjectURL(url)
      }
    },
    async clearCommands() {
      const confirm = await this.$dialog.confirm({
        title: '温馨提示',
        message: '确定要清空所有贴片内容吗',
      }).catch(() => false)
      if (confirm !== false) {
        const res = await http.post("api/field_control/clearControl", {type: 'top', group_id: this.config.group_id})
        if (res.code == 200) {
          this.getControlList();
          this.$dialog.tips({
            message: res.msg,
            type: "success"
          })
          return;
        }
        this.$dialog.tips({
          message: res.msg,
          type: "error"
        })
      }
    },

    previousPage() {
      if (this.queryForm.page > 1) {
        this.queryForm.page--
        this.getControlList();
      }
    },
    nextPage() {
      if (this.queryForm.page < this.queryForm.pageCount) {
        this.queryForm.page++
        this.getControlList();
      }
    }
  }
}
</script>

<style scoped>
.field-control {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  position: relative;
  overflow: hidden;
}



.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.btn {
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(170, 170, 170, 0.2);
  transition: left 0.3s ease;
  z-index: -1;
}

.btn:hover::before {
  left: 0;
}

.btn-primary {
  background: linear-gradient(135deg, rgba(100, 100, 100, 0.7) 0%, rgba(80, 80, 80, 0.7) 100%);
  color: rgba(170, 170, 170, 0.9);
  box-shadow: 0 4px 12px rgba(170, 170, 170, 0.15);
  border: 1px solid rgba(170, 170, 170, 0.3);
}

.btn-import {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.7) 0%, rgba(37, 99, 235, 0.7) 100%);
  color: #ffffff;
  border: 1px solid rgba(147, 197, 253, 0.5);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.btn-import:hover {
  background: linear-gradient(135deg, rgba(147, 197, 253, 0.7) 0%, rgba(59, 130, 246, 0.7) 100%);
}

.btn-export {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.7) 0%, rgba(22, 163, 74, 0.7) 100%);
  color: #ffffff;
  border: 1px solid rgba(74, 222, 128, 0.5);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
}

.btn-export:hover {
  background: linear-gradient(135deg, rgba(74, 222, 128, 0.7) 0%, rgba(34, 197, 94, 0.7) 100%);
}

.btn-overlay {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.7) 0%, rgba(147, 51, 234, 0.7) 100%);
  color: #ffffff;
  border: 1px solid rgba(192, 132, 252, 0.5);
  box-shadow: 0 4px 12px rgba(168, 85, 247, 0.3);
}

.btn-overlay:hover {
  background: linear-gradient(135deg, rgba(192, 132, 252, 0.7) 0%, rgba(168, 85, 247, 0.7) 100%);
}

.btn-overlay-active {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.7) 0%, rgba(220, 38, 38, 0.7) 100%) !important;
  border-color: rgba(248, 113, 113, 0.5) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.btn-sm {
  padding: 8px 12px;
  font-size: 14px;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}

.control-settings {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.95) 0%, rgba(35, 35, 35, 0.95) 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 4px 12px rgba(170, 170, 170, 0.1);
}

.setting-row {
  display: flex;
  gap: 30px;
  align-items: center;
  margin-bottom: 15px;
}

.setting-row:last-child {
  margin-bottom: 0;
}

.setting-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.setting-item label {
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
  min-width: 70px;
}

.setting-select {
  padding: 8px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  background: rgba(50, 50, 50, 0.8);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.3s ease;
}

.setting-select:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.1);
}

.custom-select {
  position: relative;
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  background: rgba(50, 50, 50, 0.8);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.custom-select:hover {
  border-color: rgba(170, 170, 170, 0.5);
}

.custom-select-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-arrow {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.6);
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.custom-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: rgba(35, 35, 35, 0.98);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  z-index: 100;
  overflow: hidden;
}

.dropdown-item {
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dropdown-item:hover {
  background: rgba(170, 170, 170, 0.1);
}

.dropdown-item.selected {
  background: rgba(139, 92, 246, 0.2);
  color: #c4b5fd;
}

.group-item {
  justify-content: space-between;
}

.group-item span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.delete-group-btn {
  background: none;
  border: none;
  color: rgba(239, 68, 68, 0.6);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  opacity: 0;
}

.group-item:hover .delete-group-btn {
  opacity: 1;
}

.delete-group-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.frequency-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.frequency-input {
  width: 60px;
  padding: 8px 10px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
  background: rgba(50, 50, 50, 0.8);
  color: rgba(170, 170, 170, 0.9);
  transition: all 0.3s ease;
}

.frequency-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
}

.frequency-separator {
  color: rgba(170, 170, 170, 0.7);
  font-weight: 500;
}

.frequency-unit {
  color: rgba(170, 170, 170, 0.7);
  font-size: 13px;
}

.checkbox-group {
  display: flex;
  gap: 25px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
  padding: 10px 16px;
  background: rgba(170, 170, 170, 0.1);
  border-radius: 10px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item:hover {
  background: rgba(170, 170, 170, 0.2);
  border-color: rgba(170, 170, 170, 0.5);
  color: #e0e0e0;
}

.checkbox-item input[type="checkbox"] {
  display: none;
}

.checkbox-item .checkbox-custom {
  width: 44px;
  height: 24px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  border-radius: 12px;
  position: relative;
  border: 1px solid rgba(139, 92, 246, 0.3);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item .checkbox-custom::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
  border-radius: 50%;
  top: 1px;
  left: 1px;
  box-shadow: 0 3px 8px rgba(139, 92, 246, 0.4);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-custom {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(34, 211, 238, 0.5) 100%);
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-custom::before {
  left: 21px;
  background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
  box-shadow: 0 3px 8px rgba(255, 255, 255, 0.3);
}

.checkbox-item input[type="checkbox"]:hover {
  transform: scale(1.1);
}

.commands-list {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.95) 0%, rgba(35, 35, 35, 0.95) 100%);
  border-radius: 12px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(170, 170, 170, 0.1);
}

.list-header {
  display: grid;
  grid-template-columns: 50px 460px 1fr 100px;
  gap: 10px;
  padding: 15px 20px;
  background: rgba(170, 170, 170, 0.15);
  font-weight: 600;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  border-bottom: 1px solid rgba(170, 170, 170, 0.2);
}

.header-actions {
  justify-self: end;
}

.command-item {
  display: grid;
  grid-template-columns: 50px 460px 1fr 80px;
  gap: 10px;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.15);
  transition: all 0.3s ease;
}

.item-actions {
  justify-self: end;
}

.command-item:hover {
  background: rgba(170, 170, 170, 0.1);
}

.command-item:last-child {
  border-bottom: none;
}

.item-checkbox,
.header-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-command {
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
}

.item-content {
  color: rgba(170, 170, 170, 0.7);
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.btn-action {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.btn-action.edit {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.4) 0%, rgba(37, 99, 235, 0.4) 100%);
  color: #93c5fd;
  border-color: rgba(147, 197, 253, 0.4);
}

.btn-action.delete {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.4) 0%, rgba(220, 38, 38, 0.4) 100%);
  color: #fca5a5;
  border-color: rgba(248, 113, 113, 0.4);
}

.btn-action:hover {
  transform: translateY(-2px);
}

.btn-action.edit:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.5) 0%, rgba(37, 99, 235, 0.5) 100%);
  color: #bfdbfe;
  border-color: rgba(147, 197, 253, 0.6);
}

.btn-action.delete:hover {
  background: rgba(239, 68, 68, 0.3);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #999;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-top: 1px solid rgba(60, 60, 60, 0.5);
}

.pagination {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid rgba(139, 92, 246, 0.3);
  background: rgba(139, 92, 246, 0.1);
  color: #a78bfa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.page-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #8b5cf6 0%, #22d3ee 100%);
  color: #fff;
  border-color: #8b5cf6;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: rgba(170, 170, 170, 0.8);
}

/* Modal styles */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
}

.modal-content {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.98) 0%, rgba(35, 35, 35, 0.98) 100%);
  border-radius: 16px;
  width: 90%;
  max-width: 50%;
  box-shadow: 0 20px 60px rgba(170, 170, 170, 0.1);
  border: 1px solid rgba(170, 170, 170, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.3);
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: rgba(170, 170, 170, 0.9);
}

.close-modal {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: rgba(170, 170, 170, 0.7);
  transition: color 0.3s ease;
}

.close-modal:hover {
  color: #ffffff;
}

.modal-body {
  padding: 25px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
}

.form-input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  background: rgba(50, 50, 50, 0.8);
  color: rgba(170, 170, 170, 0.9);
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.1);
}

.form-textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  font-size: 14px;
  resize: none;
  box-sizing: border-box;
  transition: all 0.3s ease;
  background: rgba(50, 50, 50, 0.8);
  color: #e0e0e0;
}

.form-textarea:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.1);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 25px;
  border-top: 1px solid rgba(170, 170, 170, 0.3);
}
</style>